/**
 * User Profile Form Reducer
 * Manages user profile form state using useReducer pattern
 */

// Action Types
export const USER_PROFILE_FORM_ACTION_TYPES = {
  // Personal Information Fields (Individual)
  SET_FIRST_NAME: "SET_FIRST_NAME",
  SET_MIDDLE_NAME: "SET_MIDDLE_NAME",
  SET_LAST_NAME: "SET_LAST_NAME",
  
  // Personal Information Fields (Company)
  SET_COMPANY_NAME: "SET_COMPANY_NAME",
  SET_COMPANY_FIRST_NAME: "SET_COMPANY_FIRST_NAME",
  SET_COMPANY_LAST_NAME: "SET_COMPANY_LAST_NAME",
  SET_REGISTRATION_NUMBER: "SET_REGISTRATION_NUMBER",
  SET_VAT_ID: "SET_VAT_ID",
  SET_COMPANY_DOCUMENT: "SET_COMPANY_DOCUMENT",
  
  // Account Information Fields
  SET_USER_CATEGORY: "SET_USER_CATEGORY",
  SET_USER_TYPE: "SET_USER_TYPE",
  SET_DEPT: "SET_DEPT",
  SET_JOB_TITLE: "SET_JOB_TITLE",
  SET_OVERHEAD_COST_TYPE: "SET_OVERHEAD_COST_TYPE",
  SET_WX_COMPANY: "SET_WX_COMPANY",
  SET_CONTRACT: "SET_CONTRACT",
  SET_MONTHLY_HOURS: "SET_MONTHLY_HOURS",
  SET_CURRENCY: "SET_CURRENCY",
  SET_COST: "SET_COST",
  SET_OVERHEAD_COST: "SET_OVERHEAD_COST",
  SET_VAT: "SET_VAT",
  
  // Location Information Fields
  SET_COUNTRY: "SET_COUNTRY",
  SET_STATE: "SET_STATE",
  SET_CITY: "SET_CITY",
  SET_ADDRESS: "SET_ADDRESS",
  SET_POST_CODE: "SET_POST_CODE",
  SET_MOBILE_NO: "SET_MOBILE_NO",
  
  // Password Fields
  SET_PASSWORD: "SET_PASSWORD",
  SET_PASSWORD_CONFIRMATION: "SET_PASSWORD_CONFIRMATION",
  SET_SHOW_PASSWORD: "SET_SHOW_PASSWORD",
  
  // Date Fields
  SET_SELECTED_DATE: "SET_SELECTED_DATE",
  SET_JOINING_DATE: "SET_JOINING_DATE",
  SET_PASSPORT: "SET_PASSPORT",
  
  // Validation States
  SET_PASSWORD_ERROR: "SET_PASSWORD_ERROR",
  SET_PASSWORD_MATCH_ERROR: "SET_PASSWORD_MATCH_ERROR",
  
  // Reset
  RESET_FORM: "RESET_FORM",
  RESET_VALIDATION: "RESET_VALIDATION",
  
  // Bulk Update
  SET_FORM_DATA: "SET_FORM_DATA",
  SET_VALIDATION_STATE: "SET_VALIDATION_STATE",
};

// Initial Form State
export const initialUserProfileFormState = {
  // Personal Information (Individual)
  firstName: "",
  middleName: "",
  lastName: "",
  
  // Personal Information (Company)
  companyName: "",
  companyFirstName: "",
  companyLastName: "",
  registrationNumber: "",
  vatId: "",
  companyDocument: null,
  
  // Account Information
  userCategory: "Individual",
  userType: "",
  dept: "",
  jobTitle: "",
  overheadCostType: "",
  wxComapny: "",
  contract: "",
  monthlyhours: "",
  currency: "",
  cost: "",
  overheadCost: "",
  vat: "",
  
  // Location Information
  country: "",
  state: "",
  city: "",
  address: "",
  postCode: "",
  mobileNo: "",
  
  // Password Fields
  password: "",
  passwordConfirmation: "",
  showPassword: false,
  
  // Date Fields
  selectedDate: new Date(),
  joiningDate: null,
  passport: "",
  
  // Validation States
  passwordError: "",
  passwordMatchError: "",
};

// Form Reducer
export const userProfileFormReducer = (state, action) => {
  switch (action.type) {
    // Personal Information (Individual)
    case USER_PROFILE_FORM_ACTION_TYPES.SET_FIRST_NAME:
      return { ...state, firstName: action.payload };
    case USER_PROFILE_FORM_ACTION_TYPES.SET_MIDDLE_NAME:
      return { ...state, middleName: action.payload };
    case USER_PROFILE_FORM_ACTION_TYPES.SET_LAST_NAME:
      return { ...state, lastName: action.payload };
    
    // Personal Information (Company)
    case USER_PROFILE_FORM_ACTION_TYPES.SET_COMPANY_NAME:
      return { ...state, companyName: action.payload };
    case USER_PROFILE_FORM_ACTION_TYPES.SET_COMPANY_FIRST_NAME:
      return { ...state, companyFirstName: action.payload };
    case USER_PROFILE_FORM_ACTION_TYPES.SET_COMPANY_LAST_NAME:
      return { ...state, companyLastName: action.payload };
    case USER_PROFILE_FORM_ACTION_TYPES.SET_REGISTRATION_NUMBER:
      return { ...state, registrationNumber: action.payload };
    case USER_PROFILE_FORM_ACTION_TYPES.SET_VAT_ID:
      return { ...state, vatId: action.payload };
    case USER_PROFILE_FORM_ACTION_TYPES.SET_COMPANY_DOCUMENT:
      return { ...state, companyDocument: action.payload };
    
    // Account Information
    case USER_PROFILE_FORM_ACTION_TYPES.SET_USER_CATEGORY:
      return { ...state, userCategory: action.payload };
    case USER_PROFILE_FORM_ACTION_TYPES.SET_USER_TYPE:
      return { ...state, userType: action.payload };
    case USER_PROFILE_FORM_ACTION_TYPES.SET_DEPT:
      return { ...state, dept: action.payload };
    case USER_PROFILE_FORM_ACTION_TYPES.SET_JOB_TITLE:
      return { ...state, jobTitle: action.payload };
    case USER_PROFILE_FORM_ACTION_TYPES.SET_OVERHEAD_COST_TYPE:
      return { ...state, overheadCostType: action.payload };
    case USER_PROFILE_FORM_ACTION_TYPES.SET_WX_COMPANY:
      return { ...state, wxComapny: action.payload };
    case USER_PROFILE_FORM_ACTION_TYPES.SET_CONTRACT:
      return { ...state, contract: action.payload };
    case USER_PROFILE_FORM_ACTION_TYPES.SET_MONTHLY_HOURS:
      return { ...state, monthlyhours: action.payload };
    case USER_PROFILE_FORM_ACTION_TYPES.SET_CURRENCY:
      return { ...state, currency: action.payload };
    case USER_PROFILE_FORM_ACTION_TYPES.SET_COST:
      return { ...state, cost: action.payload };
    case USER_PROFILE_FORM_ACTION_TYPES.SET_OVERHEAD_COST:
      return { ...state, overheadCost: action.payload };
    case USER_PROFILE_FORM_ACTION_TYPES.SET_VAT:
      return { ...state, vat: action.payload };
    
    // Location Information
    case USER_PROFILE_FORM_ACTION_TYPES.SET_COUNTRY:
      return { ...state, country: action.payload };
    case USER_PROFILE_FORM_ACTION_TYPES.SET_STATE:
      return { ...state, state: action.payload };
    case USER_PROFILE_FORM_ACTION_TYPES.SET_CITY:
      return { ...state, city: action.payload };
    case USER_PROFILE_FORM_ACTION_TYPES.SET_ADDRESS:
      return { ...state, address: action.payload };
    case USER_PROFILE_FORM_ACTION_TYPES.SET_POST_CODE:
      return { ...state, postCode: action.payload };
    case USER_PROFILE_FORM_ACTION_TYPES.SET_MOBILE_NO:
      return { ...state, mobileNo: action.payload };
    
    // Password Fields
    case USER_PROFILE_FORM_ACTION_TYPES.SET_PASSWORD:
      return { ...state, password: action.payload };
    case USER_PROFILE_FORM_ACTION_TYPES.SET_PASSWORD_CONFIRMATION:
      return { ...state, passwordConfirmation: action.payload };
    case USER_PROFILE_FORM_ACTION_TYPES.SET_SHOW_PASSWORD:
      return { ...state, showPassword: action.payload };
    
    // Date Fields
    case USER_PROFILE_FORM_ACTION_TYPES.SET_SELECTED_DATE:
      return { ...state, selectedDate: action.payload };
    case USER_PROFILE_FORM_ACTION_TYPES.SET_JOINING_DATE:
      return { ...state, joiningDate: action.payload };
    case USER_PROFILE_FORM_ACTION_TYPES.SET_PASSPORT:
      return { ...state, passport: action.payload };
    
    // Validation States
    case USER_PROFILE_FORM_ACTION_TYPES.SET_PASSWORD_ERROR:
      return { ...state, passwordError: action.payload };
    case USER_PROFILE_FORM_ACTION_TYPES.SET_PASSWORD_MATCH_ERROR:
      return { ...state, passwordMatchError: action.payload };
    
    // Reset
    case USER_PROFILE_FORM_ACTION_TYPES.RESET_FORM:
      return initialUserProfileFormState;
    case USER_PROFILE_FORM_ACTION_TYPES.RESET_VALIDATION:
      return {
        ...state,
        passwordError: "",
        passwordMatchError: "",
      };
    
    // Bulk Update
    case USER_PROFILE_FORM_ACTION_TYPES.SET_FORM_DATA:
      return { ...state, ...action.payload };
    case USER_PROFILE_FORM_ACTION_TYPES.SET_VALIDATION_STATE:
      return { ...state, ...action.payload };
    
    default:
      return state;
  }
};
